export enum GtmCustomEvents {
  CLIENT_REGISTRATION = 'client-registration',
  MATCH_FLOW = 'match-flow',
  MATCH_FLOW_DEFAULT = 'match-flow-default',
  CAL_CONNECT_CLICKED = 'calendar-events',
  CAL_EVENT_CLICKED = 'calendar-event-clicked',
  CLIENT_THERAPY_READINESS = 'client-therapy-readiness',
  PROVIDER_PAGE_VIEW = 'provider-page-viewed',
  PROVIDER_DIRECTORY_INITIAL_STATE = 'provider-directory-initial-state',
  PROVIDER_DIRECTORY_VIEW_PROFILE = 'provider-directory-view-profile',
  PROVIDER_DIRECTORY_LOAD_NEW_PROVIDERS = 'provider-directory-load-new-providers',
  PROVIDER_DIRECTORY_PAGINATION = 'provider-directory-pagination',
  PROVIDER_DIRECTORY_REQUEST_SESSION = 'provider-directory-request-session'
}

export enum GtmIntakeActions {
  SETUP_COMPLETE = 'Setup Complete',
  SUBMIT_THERAPY_READINESS = 'Submit Ready for Therapy',
  CLAIM_SUBMITTED = 'Claim Submitted for Client'
}

export enum GtmExternalCalActions {
  CLICK_ADD_EXTERNAL_CALS = 'Click button to add an external calendar',
  SUCCESSFULLY_CONNECT_EXTERNAL = 'Successfully connected external calendar',
  ERROR_CONNECTING_EXTERNAL = 'Error connecting to external calendar',
  CLICK_EXTERNAL_EVENT = 'Clicked on an external event',
  CLICK_EVENT = 'Clicked an internal event',
  DISCONNECT_EXTERNAL_CAL = 'Disconnected an external calendar'
}
